import { Interweave } from 'interweave';
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/swiper.min.css';
import useWindowSize from '../../../hooks/useWindowSize';
import SlideArrowLeft from '../../../images/SlideArrowLeft.svg';
import SlideArrowLeftBlack from '../../../images/SlideArrowLeftBlack.svg';
import SlideArrowRight from '../../../images/SlideArrowRight.svg';
import SlideArrowRightBlack from '../../../images/SlideArrowRightBlack.svg';
import PlayBtn from '../../../images/svg/icons/PlayBtn';
import { fireSegmentEvent } from '../../../utils';
import Modal from '../SmokeyTransitional/components/Modal/Modal';
import WistiaVideoEmbed from '../SmokeyTransitional/components/WistiaVideoEmbed/WistiaVideoEmbed';
import HouseSmartPillarStyles from './HouseSmartPillar.styled';

export const HouseSmartPillar = ({
  isClayton,
  headline,
  logo,
  color,
  slides,
  textColor,
  pillarID,
}) => {
  const [swiperRef, setSwiperRef] = useState(null);
  const [ModalShowing, setModalShowing] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [width, height] = useWindowSize();
  const isDesktop = width && width >= 1075;

  return (
    <HouseSmartPillarStyles
      pillarColor={color}
      textColor={textColor}
      id={pillarID}
    >
      <div className="pillar-logo">
        <img src={logo} alt="pillar icon" />
      </div>
      <div className="pillar-content">
        <div className="pillar-side">
          <div className="pillar-side-container">
            <h2>{headline}</h2>
            {isDesktop && (
              <div className="slide-navigation">
                <p>
                  {currentSlide ? currentSlide : 1}/{slides.length}
                </p>
                <div className="arrows">
                  <img
                    onClick={() => swiperRef.slidePrev()}
                    src={SlideArrowLeft}
                    alt={'left arrow icon'}
                  />
                  <img
                    onClick={() => swiperRef.slideNext()}
                    src={SlideArrowRight}
                    alt={'right arrow icon'}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="pillar-slider">
          {slides && isDesktop && (
            <Swiper
              spaceBetween={50}
              loop={true}
              allowTouchMove={false}
              slidesPerView={'auto'}
              onSlideChange={() => {
                setCurrentSlide(swiperRef?.realIndex + 1);
              }}
              onSwiper={setSwiperRef}
            >
              {slides.map((slide, i) => (
                <SwiperSlide key={'house-slide-desktop-' + i}>
                  <div className="slide-container">
                    {slide.videoID && slide.image && (
                      <div
                        className={
                          slide.gaClass
                            ? 'video-box ' + slide.gaClass
                            : 'video-box'
                        }
                        onClick={() =>
                          setModalShowing(
                            isClayton ? slide.videoID : slide.fobVideoID
                          ) +
                          fireSegmentEvent('Video Started', {
                            eventContext: slide.retailEventLabel
                              ? slide.retailEventLabel
                              : '',
                            videoId: isClayton
                              ? slide.videoID
                              : slide.fobVideoID || '',
                          })
                        }
                      >
                        <LazyLoadImage
                          alt="video background image"
                          effect="blur"
                          src={slide.image}
                        />
                        <PlayBtn />
                      </div>
                    )}
                    {!slide.videoID && slide.image && (
                      <div className="image-box">
                        <LazyLoadImage
                          effect="blur"
                          src={slide.image}
                          alt={'slide image ' + (i + 1)}
                        />
                      </div>
                    )}
                    <Interweave content={slide.content} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          {slides && !isDesktop && (
            <div className="mobile-swiper-container">
              <Swiper
                spaceBetween={30}
                loop={true}
                slidesPerView={1}
                autoHeight={true}
                onSlideChange={() => {
                  setCurrentSlide(swiperRef?.realIndex + 1);
                }}
                onSwiper={setSwiperRef}
              >
                {slides.map((slide, i) => (
                  <SwiperSlide key={'house-slide-' + i}>
                    <div className="slide-container">
                      {slide.videoID && slide.image && (
                        <div
                          className={
                            slide.gaClass
                              ? 'video-box ' + slide.gaClass
                              : 'video-box'
                          }
                          onClick={() =>
                            setModalShowing(
                              isClayton ? slide.videoID : slide.fobVideoID
                            ) +
                            fireSegmentEvent('Video Started', {
                              eventContext: slide.retailEventLabel
                                ? slide.retailEventLabel
                                : '',
                              videoId: isClayton
                                ? slide.videoID
                                : slide.fobVideoID || '',
                            })
                          }
                        >
                          <LazyLoadImage
                            alt="video background image"
                            effect="blur"
                            src={slide.image}
                          />
                          <PlayBtn />
                        </div>
                      )}
                      {!slide.videoID && slide.image && (
                        <div className="image-box">
                          <LazyLoadImage
                            effect="blur"
                            src={slide.image}
                            alt={'slide image ' + (i + 1)}
                          />
                        </div>
                      )}
                      <Interweave content={slide.content} />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="slide-navigation-mobile">
                <p>
                  {currentSlide ? currentSlide : 1}/{slides.length}
                </p>
                <div className="arrows">
                  <img
                    onClick={() => swiperRef.slidePrev()}
                    src={SlideArrowLeftBlack}
                    alt={'left arrow icon'}
                  />
                  <img
                    onClick={() => swiperRef.slideNext()}
                    src={SlideArrowRightBlack}
                    alt={'right arrow icon'}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="fade-right"></div>
        </div>
        <div className="gray-box"></div>
      </div>
      {ModalShowing && (
        <Modal onClose={() => setModalShowing(false)}>
          <div className="video-embed-wrap">
            <WistiaVideoEmbed
              wistiaID={ModalShowing}
              wistiaOptions="silentAutoPlay=false autoPlay=true"
            />
          </div>
        </Modal>
      )}
    </HouseSmartPillarStyles>
  );
};

export default HouseSmartPillar;
